import { RECEIVER_DPA } from "@recare/core/consts";
import { getStaticAsset } from "@recare/core/model/config";
import { AnyFunction } from "@recare/core/types";
import { useCallback } from "react";
import { useCountry } from "reduxentities/selectors/hooks";

export function useGetDpa() {
  const country = useCountry();
  return RECEIVER_DPA[country];
}

export default function useDpaLink(onClick?: AnyFunction | undefined) {
  const dpa = useGetDpa();
  return useCallback(
    () => window.open(getStaticAsset(dpa.asset), "_blank") && onClick?.(),
    [onClick],
  );
}
